import { render, staticRenderFns } from "./ValuationCalendarInput.vue?vue&type=template&id=b4afe266&"
import script from "./ValuationCalendarInput.vue?vue&type=script&lang=ts&"
export * from "./ValuationCalendarInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports